import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AutoPromoModal from "./AutoPromoModal";
import SitewideSEO from "../components/seo/SitewideSEO";

const Layout = () => {
  return (
    // min-h-screen aur flex-col ensure karte hain ki Footer hamesha screen ke bottom pe rahe, 
    // chahe page ka content kam hi kyun na ho.
    <div className="flex flex-col min-h-screen">
      <SitewideSEO />
      
      {/* 1. Header (Hamesha Top pe rahega) */}
      <Navbar />

      <AutoPromoModal />

      {/* 2. Main Content (Ye change hoga har page ke hisaab se) */}
      <main className="flex-grow">
        <Outlet /> 
      </main>

      {/* 3. Footer (Hamesha Bottom pe rahega) */}
      <Footer />
      
    </div>
  );
};

export default Layout;